/* eslint-disable import/prefer-default-export */

export const changeSearchTab = (context, payload) => {
  const { id, unsupportedParams, previousTabId } = payload;
  const { SearchActions } = window.LP.module('Searches');
  context.dispatch('SET_PARAM', {
    key: 'search_tab_id',
    val: id,
    noHistory: true
  });
  context.dispatch('HANDLE_UNSUPPORTED', {
    keys: unsupportedParams,
    previousTabId,
    tabId: id,
    // Params that exists on all tabs but support different values
    commonParams: ['type_ids']
  });
  context.dispatch('CLEAR_SIDEBAR');
  context.executeAction(SearchActions.loadPanels);
  const loadSearchOptions = {
    withoutFacets: true
  };
  if (payload.fromBackButton) {
    loadSearchOptions.fromBackButton = true;
  }
  context.executeAction(SearchActions.loadSearch, loadSearchOptions);
};

export const receivedSearchTabs = (context, tabs) => {
  context.dispatch('RECEIVED_SEARCH_TABS', tabs);
};
